import { render, staticRenderFns } from "./PazienteDiarioComponent.vue?vue&type=template&id=3529a173&scoped=true"
import script from "./PazienteDiarioComponent.vue?vue&type=script&lang=js"
export * from "./PazienteDiarioComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteDiarioComponent.vue?vue&type=style&index=0&id=3529a173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3529a173",
  null
  
)

export default component.exports